import { useEffect, useState } from 'react';
import { Dialog } from 'features/Dialog';
import { useApi } from 'app/api/APIProvider';
import { StepActions } from 'features/StepActions';
import { useDispatch, useSelector } from 'react-redux';
import { classNames } from 'shared/lib/classNames/classNames';
import { getPlotStepData, plotStepsActions } from 'widgets/PlotSteps';
import { AppLink, AppLinkTheme } from 'shared/ui/AppLink/AppLink';
import { PreloadImg } from 'shared/ui/PreloadImg';
import { useBackgrounds } from 'shared/lib/hooks/useBackgrounds/useBackgrounds';
import { LazyBackground } from 'shared/ui/LazyBackground';
import { getPlotOptions } from 'features/User/modal/selectors/getUserData/getUserData';
import { Loader } from 'shared/ui/Loader/Loader';
import BackIcon from 'shared/assets/icons/backIcon.svg';
import { plotStepData } from '../model/api/stepData';
import cls from './PlotSteps.module.scss';

interface PlotStepsProps {
    className?: string
}
export const PlotSteps = (props: PlotStepsProps) => {
    const {
        className,
    } = props;
    const [loading, isLoading] = useState<boolean>(true);
    const dispatch = useDispatch();
    const api = useApi();
    const stepState = useSelector(getPlotStepData);
    const plotOptions = useSelector(getPlotOptions);
    const { background, tnBackground } = useBackgrounds(stepState?.background || 'room');

    useEffect(() => {
        api.GetUser().then((user) => {
            isLoading(false);
            const plotStep = user.current_scene?.plotStep;
            dispatch(plotStepsActions.addedPlotStepData(plotStepData(plotStep || 1, user, plotOptions)));
        });
    }, []);

    if (loading) {
        return (
            <Loader />
        );
    }

    return (
        <div className={classNames(cls.PlotSteps, {}, [className])}>
            <LazyBackground tnImg={tnBackground} originalImg={background}>
                {stepState?.overlay
                    && (
                        <div
                            className={cls.overlay}
                            style={{ background: `${stepState?.overlay}` }}
                        />
                    )}
                {stepState?.backButton
                    && (
                        <div className={cls.backButton}>
                            <AppLink
                                className={classNames(cls.buttonLink, { [cls.isMoneyViewButton]: stepState?.isStepMoneyView })}
                                to="/"
                                icon={<BackIcon />}
                                theme={AppLinkTheme.BACK}
                            >
                                Главное меню
                            </AppLink>
                        </div>
                    )}
                {stepState?.dialog
                    && (
                        <Dialog />
                    )}
                {stepState?.action
                    && (
                        <StepActions />
                    )}
                {stepState?.preloadImg
                    && (
                        <PreloadImg images={stepState?.preloadImg} />
                    )}
            </LazyBackground>
        </div>
    );
};
